import axios from "axios";
import Cookies from "js-cookie";

export const HTTPClient = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
        'Content-Type': 'application/json;charset=UTF-8'
    }
})

const tokenCookie = Cookies.get('token');

if (tokenCookie)
    HTTPClient.defaults.headers['Authorization'] = `Bearer ${JSON.parse(tokenCookie).jwt}`;
else
    window.location.href = process.env.REACT_APP_LOGIN_URL;